import { Component, Inject, inject } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
  ValidationErrors,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router,ActivatedRoute } from '@angular/router';
import { OnboardingService } from '../onboarding.service';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { TuiCountryIsoCode } from '@taiga-ui/i18n';
import { TUI_IS_MOBILE } from '@taiga-ui/cdk';
import { TUI_COUNTRIES_MASKS } from '@taiga-ui/kit/tokens';
import { tap } from 'rxjs/operators';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styles: [
    `
      .t-textfield, .t-country-select {
        border-radius: 0 !important;
      }
      .loading-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }
    `
  ]
})

export class RegisterComponent {
  showSpinner = false;
  router = inject(Router);
  _snackBar = inject(MatSnackBar);
  authService = inject(AuthService);
  onboardingService = inject(OnboardingService);
  dialog = inject(MatDialog);
  params: any;

  countries: TuiCountryIsoCode[] = [];
  countryIsoCode = TuiCountryIsoCode.ES;

  public acceptTermsControl = false;
  public errMensaje = "";
  mostrarPassword1 = false;
  icon1 = 'visibility_off';
  showpasstext1 = 'SHOWPASS';
  mostrarPassword2 = false;
  icon2 = 'visibility_off';
  showpasstext2 = 'SHOWPASS';

  // Estado de la validación de la contraseña
  passwordRequirements = {
    hasLowercase: false,
    hasUppercase: false,
    hasNumber: false,
    hasSymbol: false,
    isMinLength: false
  };

  public registerForm = new FormGroup(
    {
      username: new FormControl('', [Validators.required, Validators.pattern(/^\+\d{7,15}$/)]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])/)
      ]),
      password2: new FormControl('', [Validators.required]),
    },
    { validators: MustMatch('password', 'password2') }
  );


  constructor(
    @Inject(TUI_IS_MOBILE) readonly isMobile: boolean,
    private lambda: AWSLambda,
    private recaptchaV3Service: ReCaptchaV3Service,
    private route: ActivatedRoute,
    @Inject(TUI_COUNTRIES_MASKS) private readonly countriesMasks: Record<TuiCountryIsoCode, string>,
  ) {}

  async ngOnInit() {
    await this.loadCountries()
    this.route.queryParams.subscribe(params => {
        // this._snackBar.open(params['code'], 'Close', { duration: 5000 });
        this.params = params;
    });

    this.registerForm.get('password')?.valueChanges
    .pipe(tap(() => this.updatePasswordRequirements()))
    .subscribe();
}

  updatePasswordRequirements() {
    const password = this.registerForm.get('password')?.value || '';
    this.passwordRequirements = {
      hasLowercase: /[a-z]/.test(password),
      hasUppercase: /[A-Z]/.test(password),
      hasNumber: /\d/.test(password),
      hasSymbol: /[\W_]/.test(password),
      isMinLength: password.length >= 8
    };
  }

  async signUp() {
    if (this.registerForm.invalid) return;
    this.showSpinner = true;
    //this._snackBar.open(this.params['code'], 'Close', { duration: 5000 });
    let codigoparnert =""
    if (this.params['code']) {
      codigoparnert = this.params['code'];
    }

    try {
      const token = await firstValueFrom(this.recaptchaV3Service.execute('importantAction'));
      const response = await this.lambda.getLambdaFunction('lambda', '/security/recaptcha', {
        queryStringParameters: { token }
      });

      if (response.verified) {

        const formData = this.registerForm.getRawValue();
        if (formData.username && formData.password) {
          this.onboardingService.setUsername(formData.username.toLowerCase());
          try {
            await this.authService.register(formData.username, formData.password,codigoparnert);
            this.router.navigate(['onboarding/validation'], { replaceUrl: true });
          } catch (e: any) {
            this.errMensaje = "Error en el registro";
            this._snackBar.open(this.errMensaje, 'Close', { duration: 5000 });
          }
        }
      } else {
        this._snackBar.open('Recaptcha no verificado, intente nuevamente', 'Close', { duration: 5000 });
      }
      this.showSpinner = false;
    } catch (error) {
      this._snackBar.open('Error al enviar el token al servidor', 'Close', { duration: 5000 });
      this.showSpinner = false;
    }
  }

  async loadCountries() {
    try {
      const res = await this.lambda.getLambdaFunction('lambda', '/get/contries', {
        queryStringParameters: { method: 'allowedToLogin' }
      });

      if (res.ok) {
        const isoList: string[] = res.countries || [];
        // Filtra los países válidos
        this.countries = isoList
          .map(code => code.toUpperCase())
          .filter(code => Object.values(TuiCountryIsoCode).includes(code as TuiCountryIsoCode))
          .map(code => code as TuiCountryIsoCode);

      } else {
        console.error('Error en la respuesta:', res.mensaje);
      }

    } catch (error) {
      console.error('Error al obtener países:', error);
    }
  }

  toggleTerms() {
    this.acceptTermsControl = !this.acceptTermsControl

  }

  mostrarpass1() {
    this.mostrarPassword1 = !this.mostrarPassword1;
    this.icon1 = this.mostrarPassword1 ? 'visibility' : 'visibility_off';
  }

  mostrarpass2() {
    this.mostrarPassword2 = !this.mostrarPassword2;
    this.icon2 = this.mostrarPassword2 ? 'visibility' : 'visibility_off';
  }
}

export function MustMatch(controlName: string, matchingControlName: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const control = formGroup.get(controlName);
    const matchingControl = formGroup.get(matchingControlName);

    if (control && matchingControl && control.value !== matchingControl.value) {
      return { mustMatch: true };
    }

    return null;
  };
}
